/* eslint-disable react/jsx-tag-spacing */ /* for minified SVGs */
import React from 'react';
import CreateIconComponent, { CreateIconComponentProps } from '../CreateIconComponent';

export const DownArrowIcon = ({
  title = 'Down Arrow',
  ...props
}: CreateIconComponentProps): JSX.Element => (
  <CreateIconComponent title={title} viewBox="0 0 10 17" {...props}>
    {/* prettier-ignore */}
    <path fillRule="evenodd" clipRule="evenodd" d="M.533 10.687a1.188 1.188 0 00.005 1.68l4.498 4.467 4.497-4.467.048-.05a1.188 1.188 0 00-.042-1.63l-.05-.048a1.188 1.188 0 00-1.63.042l-1.635 1.624V1.355l-.002-.07a1.188 1.188 0 00-2.375.07v10.95L2.213 10.68l-.05-.048a1.188 1.188 0 00-1.63.054z"/>
  </CreateIconComponent>
);

export default DownArrowIcon;
